import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { isAdmin } from "../utils/permissions";

/**
 * Renders children only for Admin/Superadmin. Others are redirected to /403.
 */
const AdminOnlyRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useSelector((state: RootState) => state.auth);
  if (!isAdmin(user)) {
    return <Navigate to="/403" replace />;
  }
  return <>{children}</>;
};

export default AdminOnlyRoute;
